import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Calendar, CheckSquare, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { DashboardPanel } from "@/components/dashboard/DashboardPanel";
export const DailySidebar = () => {
  const navigate = useNavigate();
  const {
    orgId
  } = useAuth();
  const [todayEvents, setTodayEvents] = useState<any[]>([]);
  const [todayTasks, setTodayTasks] = useState<any[]>([]);
  useEffect(() => {
    if (!orgId) return;
    const fetchTodayData = async () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      // Fetch today's events
      const {
        data: events
      } = await supabase.from('calendar_events').select('*').eq('org_id', orgId).gte('start_time', today.toISOString()).lt('start_time', tomorrow.toISOString()).order('start_time', {
        ascending: true
      }).limit(3);
      if (events) setTodayEvents(events);

      // Fetch today's tasks
      const {
        data: tasks
      } = await supabase.from('tasks').select('*').eq('org_id', orgId).gte('due_date', today.toISOString()).lt('due_date', tomorrow.toISOString()).order('due_date', {
        ascending: true
      }).limit(4);
      if (tasks) setTodayTasks(tasks);
    };
    fetchTodayData();
  }, [orgId]);
  return <div className="space-y-4">
      <DashboardPanel eyebrow="Today" title="Schedule" action={<Button size="sm" variant="outline" className="h-9 rounded-xl border-border/70 bg-background/80 px-3" onClick={() => navigate('/calendar')}>View All</Button>}>
          {todayEvents.length === 0 ? <p className="py-2 text-xs text-muted-foreground">No events scheduled today</p> : <div className="space-y-2.5">
              {todayEvents.slice(0, 3).map(event => <div key={event.id} className="rounded-xl border border-border/70 bg-background/80 p-3">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold">{event.title}</p>
                      <p className="mt-1 text-[11px] text-muted-foreground">{new Date(event.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                    </div>
                    <Badge variant="outline" className="border-border/70 bg-card text-[10px]">{event.event_type}</Badge>
                  </div>
                </div>)}
            </div>}
      </DashboardPanel>

      <DashboardPanel eyebrow="Today" title="Tasks" action={<Button size="icon" variant="outline" className="h-9 w-9 rounded-xl border-border/70 bg-background/80" onClick={() => navigate('/jobs')}><Plus className="h-4 w-4" /></Button>}>
          {todayTasks.length === 0 ? <p className="py-2 text-xs text-muted-foreground">No tasks for today</p> : <div className="space-y-2.5">
              {todayTasks.slice(0, 4).map(task => <div key={task.id} className="flex items-start gap-3 rounded-xl border border-border/70 bg-background/80 p-3">
                  <input type="checkbox" className="mt-0.5 h-4 w-4 rounded border-border" checked={task.completed} readOnly />
                  <div className="min-w-0 flex-1">
                    <p className={`text-sm ${task.completed ? 'line-through text-muted-foreground' : 'font-medium text-foreground'}`}>{task.title}</p>
                    {task.due_date && <p className="mt-1 text-[11px] text-muted-foreground">Due: {new Date(task.due_date).toLocaleDateString()}</p>}
                  </div>
                </div>)}
            </div>}
      </DashboardPanel>
    </div>;
};